import { render, staticRenderFns } from "./display-field-contact-avatar.vue?vue&type=template&id=539eded9&scoped=true&"
import script from "./display-field-contact-avatar.ts?vue&type=script&lang=ts&"
export * from "./display-field-contact-avatar.ts?vue&type=script&lang=ts&"
import style0 from "./display-field-contact-avatar.scss?vue&type=style&index=0&id=539eded9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "539eded9",
  null
  
)

export default component.exports